import React from 'react';
import AssessmentTool from './AssessmentTool';
import { riskAssessmentQuestions, riskAssessmentMeta, computeRiskResult } from '../config/riskAssessmentConfig';

const RiskAssessmentPage = () => (
  <AssessmentTool
    meta={riskAssessmentMeta}
    questions={riskAssessmentQuestions}
    computeResult={computeRiskResult}
  />
);

export default RiskAssessmentPage;
